"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _index = _interopRequireDefault(require("./index"));
var _constants = _interopRequireDefault(require("./constants"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var _Constants$DateTimeFo = _constants.default.DateTimeFormat,
  longDateFormat = _Constants$DateTimeFo.longDateFormat,
  shortTimeAMPM = _Constants$DateTimeFo.shortTimeAMPM,
  longDateTimeFormat = _Constants$DateTimeFo.longDateTimeFormat;
var DatetimeField = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(DatetimeField, _PureComponent);
  var _super = _createSuper(DatetimeField);
  function DatetimeField(props) {
    var _this;
    (0, _classCallCheck2.default)(this, DatetimeField);
    _this = _super.call(this, props);
    _this.onChangeDateTime = _this.onChangeDateTime.bind((0, _assertThisInitialized2.default)(_this));
    _this.isValidDateTime = _this.isValidDateTime.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(DatetimeField, [{
    key: "onChangeDateTime",
    value: function onChangeDateTime(newValue) {
      this.props.onChange(newValue);
    }
  }, {
    key: "isValidDateTime",
    value: function isValidDateTime(current) {
      var validationType = this.props.field.validationType;
      if (validationType === _constants.default.VALIDATION_TYPES_DATE_TIME_PICKER.FUTURE_DATE_TIME) {
        return (0, _momentTimezone.default)(current).isAfter((0, _momentTimezone.default)());
      }
      if (validationType === _constants.default.VALIDATION_TYPES_DATE_TIME_PICKER.PAST_DATE_TIME) {
        return (0, _momentTimezone.default)(current).isBefore((0, _momentTimezone.default)());
      }
      if (validationType === _constants.default.VALIDATION_TYPES_DATE_TIME_PICKER.ONE_WEEK_FUTURE) {
        var yesterday = (0, _momentTimezone.default)().add(-1, 'day');
        var maxDay = (0, _momentTimezone.default)().add(7, 'day');
        return (0, _momentTimezone.default)(current).isBetween(yesterday, maxDay);
      }
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        name = _this$props.name,
        value = _this$props.value,
        placeholder = _this$props.placeholder,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly;
      var displayValue = value;
      if ((0, _momentTimezone.default)(value, longDateTimeFormat, true).isValid()) {
        displayValue = (0, _momentTimezone.default)(value, longDateTimeFormat);
      }
      if ((0, _momentTimezone.default)(value, _momentTimezone.default.ISO_8601, true).isValid()) {
        displayValue = (0, _momentTimezone.default)(value);
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: name
      }, /*#__PURE__*/_react.default.createElement("input", {
        id: "thanks linting",
        style: {
          display: 'none'
        }
      }), this.props.label), /*#__PURE__*/_react.default.createElement(_index.default, {
        value: displayValue,
        inputProps: {
          name: name,
          placeholder: placeholder,
          disabled: disabled,
          readOnly: readOnly
        },
        dateFormat: longDateFormat,
        timeFormat: shortTimeAMPM,
        onChange: this.onChangeDateTime,
        isValidDate: this.isValidDateTime,
        buttonCalendar: this.props.buttonCalendar,
        incrementsMinute: this.props.incrementsMinute,
        clearable: this.props.clearable
      }));
    }
  }]);
  return DatetimeField;
}(_react.PureComponent);
DatetimeField.propTypes = {
  label: _propTypes.default.string,
  className: _propTypes.default.string,
  name: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({}), _propTypes.default.number]),
  placeholder: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  field: _propTypes.default.shape({
    validationType: _propTypes.default.string
  }),
  buttonCalendar: _propTypes.default.bool,
  incrementsMinute: _propTypes.default.number,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  clearable: _propTypes.default.bool
};
DatetimeField.defaultProps = {
  label: '',
  className: null,
  name: null,
  placeholder: 'Select Date and Time',
  value: null,
  field: {
    validationType: ''
  },
  buttonCalendar: true,
  incrementsMinute: 1,
  disabled: false,
  readOnly: false,
  clearable: false
};
var _default = DatetimeField;
exports.default = _default;